module.exports = __webpack_public_path__ + "static/the-switch-established-habits-487f8903d1c026a1424b494795ef1bc3.jpg";